import { VCheckbox } from 'vuetify/lib/components/VCheckbox';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VCheckbox,{staticClass:"AppCheckbox",attrs:{"color":_vm.primaryColor},scopedSlots:_vm._u([{key:"label",fn:function(){return [_c('app-text',{attrs:{"weight":"weight700","size":"subtitle1"}},[_vm._v(_vm._s(_vm.label))])]},proxy:true}]),model:{value:(_vm.inputValue),callback:function ($$v) {_vm.inputValue=$$v},expression:"inputValue"}})}
var staticRenderFns = []

export { render, staticRenderFns }